<script>
import appConfig from '@/app.config'
import PageHeader from '@/components/page-header'
import Layout from '@/router/layouts/main'
import MultiRangeSlider from 'multi-range-slider-vue'
import 'multi-range-slider-vue/MultiRangeSliderBarOnly.css'
import Multiselect from 'vue-multiselect'
// import Customer from '@/router/views/master/address/Customer'
import Company from '@/router/views/master/address/Company'
import { DELETE_ADDRESS, GET_ADDRESS, GET_DETAIL_ADDRESS } from '@/services/api/master/address'
import { Helper, debounce } from '@/mixin/helper'

/**
 * Starter component
 */
export default {
  page: {
    title: 'Data Address',
    meta: [{ name: 'description', content: appConfig.description }],
  },
  components: {
    Layout,
    PageHeader,
    Multiselect,
    MultiRangeSlider,
    // Customer,
    Company,
  },
  mixins: [Helper],
  apollo: {
    geofences: {
      query: GET_ADDRESS,
      manual: true,
      fetchPolicy: 'no-cache',
      variables: {
        filter: {
          pagination: {
            page: 1,
            show: 10,
          },
        },
      },
      result({ data, loading }) {
        if (!loading) {
          this.totalRows = data.geofences.geofences.pagination.total
          this.geofences = data.geofences.geofences
        }
      },
    },
  },
  data() {
    return {
      phaseOneShow: false,
      input: {
        isActive: null,
        name: null,
      },
      geofences: [],
      filterSelected: [],
      selectDisabled: [],
      selectAll: false,
      deleteAddress: [],
      filterMonth: '',
      addressCat: null,
      city: null,
      geoType: null,
      contactName: null,
      fav: null,
      isAddFavorit: false,
      addFavorit: null,
      showModal: false,
      show_model: null,
      totalRows: 1,
      currentPage: 1,
      perPage: 10,
      pageOptions: [10, 25, 50, 100],
      filter: null,
      sortBy: 'name',
      sortDesc: false,
      barMinValueTemp: 1,
      barMaxValueTemp: 100,
      show: [
        { key: 'fenceName', label: 'Nama Lokasi' },
        { key: 'category', label: 'Kategori Alamat' },
        { key: 'address', label: 'Alamat Lengkap' },
        { key: 'province', label: 'Provinsi' },
        { key: 'city', label: 'Kota' },
      ],
      listAddress: [
        {
          key: 'columnCheck',
          thClass: 'mc-table--30',
          sortable: false,
        },
        {
          key: 'fenceName',
          label: this.$t('master.list.address.name'),
          thClass: 'mc-table--50',
          sortable: true,
        },
        {
          key: 'category',
          label: this.$t('master.list.address.category'),
          thClass: 'mc-table--50',
          sortable: true,
        },
        {
          key: 'address',
          label: this.$t('master.list.address.address'),
          thClass: 'mc-table--50',
          sortable: true,
        },
        {
          key: 'province',
          label: this.$t('master.list.address.province'),
          thClass: 'mc-table--50',
          sortable: true,
        },
        {
          key: 'city',
          label: this.$t('master.list.address.city'),
          thClass: 'mc-table--50',
          sortable: true,
        },
      ],
    }
  },
  mounted() {
    this.$apollo.queries.geofences.refetch()
    this.$store.commit('masterAddress/SET_STATUS', 'company')
  },
  computed: {
    /**
     * Total no. of records
     */
    rows() {
      return this.geofences.geofences.length
    },
    title() {
      return `${this.$t('menuitems.masterData.list.address')}`
    },
    visibleAddress() {
      if (this.show_model && this.show_model.length > 0) {
        var result = this.show_model.map((a) => a.key)

        return this.listAddress.filter(function (item) {
          return item.key == 'columnCheck' || item.key == 'columnLock' || result.includes(item.key)
        })
      } else {
        return this.listAddress
      }
    },
  },
  methods: {
    /**
     * Search the table data with search input
     */
    searchData: debounce(function () {
      this.onFiltered()
    }, 500),

    onFiltered() {
      // Trigger pagination to update the number of buttons/pages due to filtering
      if (this.filter.length > 0 && this.filter.length < 3) return
      this.currentPage = 1
      this.$apollo.queries.geofences.refetch({
        filter: {
          search: this.filter,
          pagination: {
            page: 1,
            show: this.perPage,
          },
        },
      })
    },

    changePerPage(perPage) {
      this.perPage = perPage
      if (this.filter == null) {
        this.$apollo.queries.geofences.refetch({
          filter: {
            pagination: {
              page: 1,
              show: this.perPage,
            },
          },
        })
      } else {
        this.$apollo.queries.geofences.refetch({
          filter: {
            search: this.filter,
            pagination: {
              page: 1,
              show: this.perPage,
            },
          },
        })
      }
    },

    changePage(page) {
      this.currentPage = page
      if (this.filter == null) {
        this.$apollo.queries.geofences.refetch({
          filter: {
            pagination: {
              page: this.currentPage,
              show: this.perPage,
            },
          },
        })
      } else {
        this.$apollo.queries.geofences.refetch({
          filter: {
            search: this.filter,
            pagination: {
              page: this.currentPage,
              show: this.perPage,
            },
          },
        })
      }
    },

    async toggleAll(event) {
      var checked = event.target.checked
      var address = await this.$apollo.query({
        query: GET_ADDRESS,
        fetchPolicy: 'no-cache',
        variables: {
          filter: {
            pagination: {
              page: 1,
              show: this.totalRows,
            },
          },
        },
      })
      this.filterSelected = []
      if (checked) {
        this.filterSelected = address.data.geofences.geofences.data.map((item) => item.geofenceId)
        this.removeDisabledItem(address.data.geofences.geofences.data)
      } else {
        this.filterSelected = []
      }
    },

    removeDisabledItem(data) {
      data.forEach((item) => {
        if (item.category == 'Main Branch' || item.category == 'Branch') {
          var index = this.filterSelected.indexOf(parseInt(item.geofenceId))
          if (index !== -1) {
            this.filterSelected.splice(index, 1)
          }
        }
      })
    },

    checkTable(event) {
      if (event.target.checked) {
        this.filterSelected.push(parseInt(event.target.value))
        if (this.filterSelected.length == this.totalRows) {
          this.selectAll = true
        }
      } else {
        this.selectAll = false
        var index = this.filterSelected.indexOf(parseInt(event.target.value))
        if (index !== -1) {
          this.filterSelected.splice(index, 1)
        }
      }
    },

    clearTable() {
      this.filterSelected = []
      this.selectAll = false
      this.resetModal()
    },

    openModalDelete() {
      for (let i = 0; i < this.filterSelected.length; i++) {
        this.$apollo
          .query({
            query: GET_DETAIL_ADDRESS,
            variables: {
              filter: {
                geofenceId: parseInt(this.filterSelected[i]),
              },
            },
          })
          .then((res) => {
            var isSuccessful = res.data.geofence.isSuccessful
            if (isSuccessful) {
              this.deleteAddress.push(res.data.geofence.geofence)
            }
          })
      }
      this.$bvModal.show('modal-delete')
    },

    toDelete(bvModalEvent) {
      bvModalEvent.preventDefault()

      let promises = []
      for (let i = 0; i < this.filterSelected.length; i++) {
        promises.push(
          this.$apollo.mutate({
            mutation: DELETE_ADDRESS,
            variables: {
              input: {
                geofenceId: this.filterSelected[i],
              },
            },
          })
        )
      }

      Promise.all(promises).then(() => {
        this.$apollo.queries.geofences.refetch()
        this.$toast.success(`Data berhasil dihapus`)
        this.clearTable()
        this.$bvModal.hide('modal-delete')
      })
    },

    resetModal() {
      this.deleteAddress = []
    },

    UpdateValuesTemp(e) {
      this.barMinValueTemp = e.minValue
      this.barMaxValueTemp = e.maxValue
    },

    onRowClicked(item) {
      this.$router.push({
        name: 'Master Address Update',
        params: { id: item.geofenceId },
      })
    },
  },
}
</script>

<template>
  <Layout>
    <div class="mc-list-header">
      <PageHeader :title="title" />

      <p class="mb-4">{{ $t('master.form.address.listAllAddressInsideSystem') }}</p>

      <div class="clearfix mc-btn-group__list mc-btn-group__list--detail">
        <div class="float-end">
          <b-button
            @click="$router.push({ name: 'Master Address Import' })"
            variant="outline-primary"
            class="ms-3"
          >
            <i class="mc-fa icon-outline_upload"></i> {{ $t('global.upload') }}
          </b-button>
          <!-- Hidden for Phase 1 -->
          <b-dropdown
            right
            variant="outline-primary"
            menu-class="dropdown-menu-end"
            class="mc-btn-download"
            v-if="phaseOneShow"
          >
            <template v-slot:button-content>
              {{ $t('global.download') }} <i class="mdi mdi-chevron-down ps-2"></i>
            </template>
            <b-dropdown-item
              ><i class="bx bx-book-content pe-1"></i>
              {{ $t('master.address.form.downloadExcelTable') }}</b-dropdown-item
            >
            <b-dropdown-item
              ><i class="bx bx-book-content pe-1"></i>
              {{ $t('master.address.form.downloadPDFTable') }}F</b-dropdown-item
            >
          </b-dropdown>
          <b-button
            variant="outline-primary"
            @click="$router.push({ name: 'Master Home Page' })"
            class="ms-3"
          >
            <i class="mc-fa icon-outline_arrow-left"></i>
            {{ $t('global.back') }}
          </b-button>
        </div>
      </div>

      <div class="row mb-3">
        <div class="col-md-12">
          <div class="mc-table-filter text-end">
            <a
              v-b-modal.modal-filter
              class="popup-form btn btn-outline-primary mx-2 mc-btn-filter"
              href="javascript: void(0);"
              v-if="phaseOneShow"
            >
              <i class="mc-fa icon-outline_filter"></i> Filter
            </a>
            <b-modal
              class="mc-modal"
              id="modal-filter"
              title="Filter"
              size="lg"
              centered
              scrollable
              v-if="phaseOneShow"
            >
              <div class="card-body mc-modal__filter">
                <form>
                  <div class="mc-modal__filter-item">
                    <label class="mt-3">{{ $t('address.category') }}</label>
                    <multiselect
                      v-model="addressCat"
                      :options="[
                        'Pilih Semua',
                        'Kantor Pusat',
                        'Gudang',
                        'Landing Point',
                        'Pool',
                        'Servis',
                      ]"
                      placeholder="Pilih Kategori Alamat"
                    >
                    </multiselect>
                  </div>
                  <div class="mc-modal__filter-item">
                    <label>{{ $t('address.city') }}</label>
                    <multiselect
                      v-model="city"
                      :options="['Jakarta', 'Surakarta', 'Surabaya', 'Purwakarta']"
                      :multiple="true"
                      placeholder="Pilih Kota"
                    >
                    </multiselect>
                  </div>
                  <div class="mc-modal__filter-item">
                    <label>Radius</label>
                    <b-row>
                      <b-col md="6" sm="12">
                        <b-form-group id="temp_min_label" label="Minimal" label-for="temp_min">
                          <b-form-input
                            id="temp_min"
                            placeholder="Minimal"
                            type="number"
                            v-model="barMinValueTemp"
                          ></b-form-input>
                        </b-form-group>
                      </b-col>
                      <b-col md="6" sm="12">
                        <b-form-group id="temp_max_label" label="Maximal" label-for="temp_max">
                          <b-form-input
                            id="temp_max"
                            placeholder="Maximal"
                            type="number"
                            v-model="barMaxValueTemp"
                          ></b-form-input>
                        </b-form-group>
                      </b-col>
                      <b-col md="12">
                        <MultiRangeSlider
                          baseClassName="multi-range-slider-bar-only"
                          :min="0"
                          :max="100"
                          :step="1"
                          :ruler="false"
                          :label="true"
                          :minValue="barMinValueTemp"
                          :maxValue="barMaxValueTemp"
                          @input="UpdateValuesTemp"
                          class="mc-multi-range-slider"
                        />
                      </b-col>
                    </b-row>
                  </div>
                  <div class="mc-modal__filter-item">
                    <b-form-group
                      label="Tipe Geolokasi"
                      v-slot="{ ariaDescribedby }"
                      class="form-check"
                    >
                      <b-form-checkbox-group
                        id="checkbox-group-1"
                        v-model="geoType"
                        :options="['Semua', 'Lingkaran', 'Poligon']"
                        :aria-describedby="ariaDescribedby"
                        name="geoType-1"
                      ></b-form-checkbox-group>
                    </b-form-group>
                  </div>
                  <div class="mc-modal__filter-item">
                    <label>{{ $t('master.address.form.contactName') }}</label>
                    <multiselect
                      v-model="contactName"
                      :options="['Jon', 'Joni', 'Jono']"
                      placeholder="Pilih Nama Kontak"
                    >
                    </multiselect>
                  </div>
                  <div class="mc-modal__filter-item">
                    <div class="form-check form-switch mb-3">
                      <input
                        type="checkbox"
                        id="switchGarageAddress"
                        class="form-check-input"
                      /><label for="switchGarageAddress" class="form-check-label">{{
                        $t('master.address.form.showAddressAsGarage')
                      }}</label>
                    </div>
                  </div>
                  <div class="mc-modal__filter-item">
                    <div class="form-check form-switch mb-3">
                      <input
                        type="checkbox"
                        id="switchServiceAddress"
                        class="form-check-input"
                      /><label for="switchServiceAddress" class="form-check-label">{{
                        $t('master.address.form.showAsServiceLocation')
                      }}</label>
                    </div>
                  </div>
                </form>
              </div>
              <template #modal-footer="{ cancel }">
                <b-row class="mc-modal__filter-footer">
                  <b-col sm="12" md="8" class="mc-modal__filter-footer-fav">
                    <b-row>
                      <b-col md="6">
                        <b-form-group
                          v-if="!isAddFavorit"
                          id="favorit-label-modal"
                          label="Favorit"
                          label-for="favorit-modal"
                        >
                          <multiselect
                            v-model="fav"
                            :options="['Semua Model', 'Semua Kendaraan', 'Semua Wing']"
                            :show-labels="false"
                          ></multiselect>
                        </b-form-group>
                        <b-form-group
                          v-if="isAddFavorit"
                          id="favorit-add-label-modal"
                          label="Favorit"
                          label-for="favorit-modal-add"
                        >
                          <b-form-input
                            id="favorit-modal-add"
                            v-model="addFavorit"
                            placeholder="Nama Favorit"
                          ></b-form-input>
                        </b-form-group>
                      </b-col>
                      <b-col md="6">
                        <b-button
                          v-if="!isAddFavorit"
                          variant="outline-primary"
                          @click="isAddFavorit = !isAddFavorit"
                        >
                          <i class="mdi mdi-file-plus-outline"></i>
                          {{ $t('master.address.form.createNewFavorite') }}
                        </b-button>
                        <b-button v-if="isAddFavorit" variant="outline-primary">
                          <i class="fas fa-save"></i>{{ $t('master.address.form.saveAsFavorite') }}
                        </b-button>
                        <i
                          v-if="isAddFavorit"
                          class="fas fa-trash text-danger text-lg mt-4 ms-3"
                          @click="isAddFavorit = !isAddFavorit"
                        ></i>
                      </b-col>
                    </b-row>
                  </b-col>

                  <b-col sm="12" md="4" class="mc-modal__filter-footer-btn">
                    <b-button variant="outline-primary" @click="cancel()" class="me-3">
                      {{ $t('global.cancel') }}
                    </b-button>
                    <b-button variant="primary"> {{ $t('global.save') }} </b-button>
                  </b-col>
                </b-row>
              </template>
            </b-modal>
            <b-button
              v-if="filterSelected.length"
              variant="outline-danger"
              class="ms-2"
              @click="openModalDelete"
            >
              <i class="mc-fa icon-outline_trash"></i> {{ $t('global.delete') }}
            </b-button>
            <b-button
              variant="primary"
              @click="$router.push({ name: 'Master Address Create' })"
              v-b-modal.modal-create
              class="ms-2"
              v-if="!$store.state.access.data.md1['md1-c1'].read"
            >
              <i class="mc-fa icon-outline_plus"></i>
              {{ $t('global.addField') }}
            </b-button>
          </div>
        </div>
      </div>
    </div>

    <div class="card" v-if="!$store.state.access.data.md1['md1-c1'].read">
      <div class="card-body">
        <div class="row">
          <div class="col-sm-4 col-md-4 mc-row-check-wrapper">
            <h6 v-if="filterSelected.length" class="mc-row-check">
              <span class="badge btn-success">{{ filterSelected.length }}</span>
              ${{ $t('master.address.form.selectedRows') }}
              <a class="color-primary" @click="clearTable">{{
                $t('master.address.form.clearAll')
              }}</a>
            </h6>
          </div>

          <!-- Search -->
          <div class="col-sm-8 col-md-8 d-flex flex-row-reverse mc-table-view-wrapper">
            <div class="mc-table-view">
              <p class="mc-label">{{ $t('global.shown') }}</p>
              <multiselect
                v-model="show_model"
                :options="show"
                :multiple="true"
                :placeholder="$t('global.object.allColumn')"
                track-by="label"
                label="label"
              >
                <template slot="singleLabel" slot-scope="{ option }">{{ option.name }}</template>
              </multiselect>
              <div id="tickets-table_filter" class="dataTables_filter text-md-end">
                <label class="d-inline-flex align-items-center mc-table-view__search">
                  <i class="mc-fa fas fa-search"></i>
                  <b-form-input
                    v-model="filter"
                    type="search"
                    :placeholder="$t('global.search') + '...'"
                    class="ms-2"
                    @input="searchData"
                  ></b-form-input>
                </label>
              </div>
            </div>
          </div>
          <!-- End search -->
        </div>

        <!-- Table -->
        <div class="table-responsive my-3 border border-1">
          <b-table
            small
            show-empty
            :fields="visibleAddress"
            :items="geofences.data"
            class="datatables"
            responsive="lg"
            empty-table
            :empty-text="$t('global.emptyTable')"
            :empty-filtered-text="$t('global.emptyFilteredTable')"
            @filtered="onFiltered"
            :busy="$apollo.queries.geofences.loading"
          >
            <template #table-busy>
              <div class="text-center text-danger my-2">
                <b-spinner class="align-middle"></b-spinner>
              </div>
            </template>
            <template #head(columnCheck)>
              <div class="form-check">
                <input
                  class="form-check-input me-1"
                  type="checkbox"
                  value="all"
                  v-model="selectAll"
                  @input="toggleAll"
                />
              </div>
            </template>
            <template #head(columnLock)>
              <p></p>
            </template>

            <template #cell(columnCheck)="data">
              <div
                class="form-check"
                v-if="data.item.category == 'Main Branch' || data.item.category == 'Branch'"
              >
                <input
                  class="form-check-input me-1"
                  type="checkbox"
                  :value="data.item.geofenceId"
                  v-model="filterSelected"
                  :disabled="true"
                  @input="checkTable"
                />
              </div>
              <div class="form-check" v-else>
                <input
                  class="form-check-input me-1"
                  type="checkbox"
                  :value="data.item.geofenceId"
                  v-model="filterSelected"
                  @input="checkTable"
                />
              </div>
            </template>

            <!-- TODO: Change the conditional to hasRelation & default by McEasy -->
            <template #cell(columnLock)="data">
              <div v-if="data.index == 0">
                <i class="fa fa-lock"></i>
              </div>
            </template>

            <template #cell(fenceName)="data">
              <a href="javascript:void(0)" @click="onRowClicked(data.item)">
                <strong class="text-primary">
                  {{ data.item.fenceName }}
                </strong>
              </a>
            </template>
          </b-table>
        </div>

        <div class="row">
          <div class="col-sm-12 col-md-6">
            <div id="tickets-table_length" class="dataTables_length">
              <label class="d-inline-flex align-items-center">
                {{ $t('global.show') }}
                <b-form-select
                  class="form-select form-select-sm"
                  v-model="perPage"
                  size="sm"
                  :options="pageOptions"
                  @input="changePerPage"
                >
                </b-form-select>
                {{ $t('master.form.address.entry').toLowerCase() }}
                <p>
                  {{ $t('global.show') }}&nbsp;<strong>{{
                    totalRows > 0 ? (currentPage - 1) * perPage + 1 : 0
                  }}</strong
                  >&nbsp;{{ $t('global.until').toLowerCase() }}&nbsp;<strong>{{
                    Math.min(totalRows, currentPage * perPage)
                  }}</strong
                  >&nbsp;{{ $t('global.from').toLowerCase() }}&nbsp;<strong>{{ totalRows }}</strong
                  >&nbsp;
                  {{ $t('master.form.address.entry').toLowerCase() }}
                </p>
              </label>
            </div>
          </div>
          <div class="col-sm-12 col-md-6">
            <div class="dataTables_paginate paging_simple_numbers float-end">
              <ul class="pagination pagination-rounded mb-0">
                <!-- pagination -->
                <b-pagination
                  v-model="currentPage"
                  :total-rows="totalRows == null ? rows : totalRows"
                  :per-page="perPage"
                  @change="changePage"
                ></b-pagination>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div v-else>
      <b-card class="mc-card__setting">
        <b-tabs content-class="p-3 text-muted" nav-wrapper-class="mc-tab">
          <Company status="company" ref="company" />
          <!-- <Customer status="customer" ref="customer" /> -->
        </b-tabs>
      </b-card>
    </div>

    <!-- Modal for Delete Confirmation -->
    <b-modal
      class="mc-modal"
      id="modal-delete"
      title="Hapus"
      size="md"
      centered
      scrollable
      @hidden="resetModal"
    >
      <div class="card-body mc-modal__filter p-2">
        <p>${{ $t('deleteValidation') }}</p>
        <b-list-group>
          <b-list-group-item v-for="address in deleteAddress" :key="address.geofenceId">{{
            address.fenceName
          }}</b-list-group-item>
        </b-list-group>
      </div>
      <template #modal-footer="{ cancel }">
        <b-row class="mc-modal__filter-footer mx-0">
          <b-col sm="12" md="12" class="mc-modal__filter-footer-btn">
            <b-button variant="outline-primary" @click="cancel()" class="me-2">
              {{ $t('global.no') }}
            </b-button>
            <b-button @click="toDelete" variant="primary"> {{ $t('global.yes') }} </b-button>
          </b-col>
        </b-row>
      </template>
    </b-modal>
  </Layout>
</template>
